import * as React from "react";

function Link(props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={18}
      height={14}
      viewBox="0 0 22 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15.5 13.25h-1.51c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h1.51c2.62 0 4.75-2.13 4.75-4.75s-2.13-4.75-4.75-4.75H14a.749.749 0 110-1.5h1.5c3.45 0 6.25 2.8 6.25 6.25s-2.8 6.25-6.25 6.25zM8 13.25H6.5C3.05 13.25.25 10.45.25 7S3.05.75 6.5.75H8c.41 0 .75.34.75.75s-.34.75-.75.75H6.5C3.88 2.25 1.75 4.38 1.75 7s2.13 4.75 4.75 4.75H8c.41 0 .75.34.75.75s-.34.75-.75.75z"
        fill="#0EA5E9"
      />
      <path
        d="M15 7.75H7c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h8c.41 0 .75.34.75.75s-.34.75-.75.75z"
        fill="#0EA5E9"
      />
    </svg>
  );
}

export default Link;
